import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'joinArray'
})
export class JoinArrayPipe implements PipeTransform {

    public transform(value: string[], separator: string = ','): unknown {
        if (value) {
            return value.join(separator);
        }
        return '-';
    }
}
